<div *ngIf="order" class="container px-0 m-0 mt-3">

  <div [className]="toBePrinted ? 'mb-2' : 'mb-4'">

    <!-- TITLE -->
    <ng-container *ngIf="!toBePrinted; else printTitleTemplate">
      <div class="text-start px-3">
        <h1 class="title black"> {{ "Confirmación de compra" | translate }} </h1>
      </div>
    </ng-container>

    <div class="px-3">
      <span class="fs-l p-0 py-2 d-block"> {{ '¡Muchas Gracias! Tu compra está lista' | translate }} </span>
      <span class="fs-m  p-0  d-block">
        {{ 'Este es el resumen de tu compra. También se ha enviado una copia a tu correo' | translate }}
        <span class="fw-bold d-block">{{ user.email }}</span>
      </span>
    </div>

  </div>

  <div class="row p-0 m-0 mb-3">
    <ng-container *ngIf="order.error; then errorTemplate"></ng-container>
    <!--Col-1 Content-->
    <div class="col-12 col-lg-7 col-xl-8">

      <!-- Order summary card -->
      <ng-container *ngIf="hasOpenDomain || hasServiceType || hasAddonType">
        <div class="border-card p-3 fw-bold fs-m">

          <div class="mb-3 fs-l d-flex w-100 justify-content-between">
            <span> {{ 'Número de orden' | translate }} </span>
            <span class="text-green"> {{ order.id }} </span>
          </div>

          <hr class="hr-custom mb-3">

          <!--Order Items-->
          <div *ngFor="let item of cartItems; trackBy: trackCartItemById">
            <ng-container *ngTemplateOutlet="orderItemTemplate; context: {orderItem: item}"></ng-container>
          </div>

          <!-- Amounts Template (total, subtotal, offer)-->
          <ng-container *ngTemplateOutlet="amountsTemplate"></ng-container>

        </div>
      </ng-container>

      <!--Close domains card -->
      <ng-container *ngIf="order.closedDomains; then closeDomainTemplate"></ng-container>

      <!-- Payment receipt card -->
      <ng-container *ngTemplateOutlet="paymentReceiptTemplate"></ng-container>

      <!-- Button section-->
      <div id="button-export" class="row my-3 align-items-center">
        <div class="col-12 col-lg-6 order-2 order-lg-1 text-start">
          <button class="btn btn-secondary black my-4" [class.w-100]="isMobile" (click)="onGeneratePDF()">
            <div class="d-flex align-items-center justify-content-center w-100">
              <span class="i-download me-2"></span>
              {{ 'Descargar PDF' | translate }}
            </div>
          </button>
        </div>
        <div class="col-12 col-lg-6 order-1 order-lg-2 text-lg-end">
          <button class="btn btn-primary text-nowrap" [class.w-100]="isMobile" (click)="redirectToEcommerce()">
            {{ 'Continuar comprando' | translate }}
          </button>
        </div>
      </div>
      <app-secure-purchase-message *ngIf="!toBePrinted"></app-secure-purchase-message>

    </div>

    <!--Col 2 - Services and help-->
    <div class="d-lg-block d-none col-12 col-lg-5 col-xl-4">
      <section>
        <div class="mb-3">
          <span class="fs-xl fw-bold" (click)="redirectToPortal()">
            {{ 'Administrar servicios' | translate }}
          </span>
          <span class="d-inline-block w-100 fs-l my-2">
            {{ 'Puedes ir al panel de control para iniciar la configuración de tus servicios.' | translate }}
          </span>
        </div>
        <button class="btn btn-secondary " (click)="redirectToPortal()">
          {{ 'Configura tus servicios' | translate }}
        </button>
      </section>
      <section>
        <div class="my-3">
          <span class="fs-xl fw-bold"> {{ 'Necesitas ayuda' | translate }} </span>
          <div class="my-2 fs-l">
            <span class="d-block w-100"> +52 (81) 8864-2626 </span>
            <span class="d-block w-100"> {{ 'Servicio a cliente y soporte' | translate }}: </span>
            <a class="d-block w-100 text-black" href="mailto:ayuda@akky.mx"> {{'ayuda@akky.mx' | translate}}</a>
          </div>
        </div>
        <button class="btn btn-secondary" (click)="openChat()">
          {{ 'Iniciar Chat' | translate }}
        </button>
      </section>
    </div>
  </div>
</div>

<!-- PRINT TEMPLATE -->
<ng-template #printTitleTemplate>
  <div class="row p-0 m-0 align-items-center">
    <div class="col">
      <div class="p-0 text-start">
        <div class="title black pdf-title-size py-0 py-md-0"> {{ "Confirmación de compra" | translate }} </div>
      </div>
    </div>

    <div class="col report-icon">
      <img class="space-frame"
        src="data:image/svg+xml;base64,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"
        alt="logo" height="35">
    </div>
    <br>
  </div>
</ng-template>

<!-- Order Item Template -->
<ng-template #orderItemTemplate let-orderItem="orderItem">

  <div *ngIf="(orderItem.type === 0 || isDomainDiverseService(orderItem)) && orderItem.message !== ''" class="row my-3">
    <div class="col-12">
      <span class="domain-name">{{ orderItem.message }}</span>
    </div>
  </div>

  <div class="row my-3" *ngIf="orderItem.name && orderItem.name !== ''">
    <div class="col-4 col-md-6 col-lg-6">
      <span>{{ orderItem.name }}</span>

      <span *ngIf="isSynchronizationMessage(orderItem); else coverageTemplate">{{ getItemMessage(orderItem) }}</span>
      <ng-template #coverageTemplate>
        {{ orderItem.coverageMonths === 0 ? '' : ' - ' + ( orderItem.coverageMonths | coverage )}}
      </ng-template>

    </div>
    <div class="col-4 col-md-3 col-lg-3 d-flex justify-content-end align-items-end">
      <span class="fs-md text-default-gray text-uppercase">{{('Cantidad' | translate)}}: {{isSynchronization(orderItem)
        ? 1 : orderItem.quantity}}</span>
    </div>
    <div class="col-4 col-md-3 col-lg-3 d-flex justify-content-end align-items-end">
      <span class="price">
        {{ orderItem.finalAmount === 0 ? ('Sin costo' | translate ) : (orderItem.finalAmount | currency) }}
        <span *ngIf="orderItem.finalAmount > 0">MXN</span>
      </span>
    </div>
  </div>

  <div *ngFor="let item of orderItem.items; trackBy: trackOrderItemById">
    <div class="row my-3">
      <div class="col-4 col-md-6 col-lg-6">
        <span>{{ item.name }}</span>
        <span *ngIf="item.coverageMonths"> - {{ item.coverageMonths | coverage: item.coverageMonths >= 12 ? '' :
          'months' }}</span>
      </div>
      <div class="col-4 col-md-3 col-lg-3"></div>
      <div class="col-4 col-md-3 col-lg-3 d-flex justify-content-end align-items-end">
        <span class="price">
          {{ item.finalAmount === 0 ? ('Sin costo' | translate ) : (item.finalAmount | currency) }}
          <span *ngIf="item.finalAmount > 0">MXN</span>
        </span>
      </div>
    </div>
  </div>

  <hr class="hr-custom mb-3">

</ng-template>

<!-- close Domains Template-->
<ng-template #closeDomainTemplate>

  <div class="border-card p-3 fw-bold fs-m mt-3">
    <div class="col-md-12 text-capitalize mb-3">
      {{ 'Dominios Pendientes de Autorización' | translate }}
    </div>

    <hr class="hr-custom">

    <!-- desktop headers -->
    <div *ngIf="!isMobile" class="row align-items-center">
      <div class="col-6 py-2 text-capitalize">
        {{ 'Dominio' | translate}}
      </div>
      <div class="col-6 py-2 text-center">
        {{"Estatus"| translate}}
      </div>
    </div>

    <!-- Close domains for-->
    <div class="row align-items-center" [class.close-domain-background]="i % 2 === 0"
      *ngFor="let item of order?.closedDomains; let i = index; trackBy: trackClosedDomainById">

      <div class="col-4 col-md-6 py-2">
        <span class="d-md-none fw-normal text-capitalize">{{ 'Dominio' | translate}}</span>
        <span class="d-none d-md-block domain-name"> {{ item.name }} </span>
      </div>

      <div class="col-8 col-md-6 py-2 text-end text-md-center">
        <div class="my-2 d-md-none domain-name my-2">
          {{ item.name }}
          <br />
        </div>
        <div class="my-2 yellow text-uppercase">
          {{ item.message | translate }}
        </div>
      </div>
    </div>

    <!-- Close domains message -->
    <div class="row py-4 fs-m fw-normal">
      <span class="d-block my-2 no-transform">
        {{ 'En breve recibirás un correo con indicaciones, para dar seguimiento a la activación de tu dominio.' |
        translate}}
      </span>
      <span class="d-block my-2 no-transform">
        {{ 'Al completar la firma digital, demorará 24 a 48 hrs. hábiles en completarse la activación, de lo contrario te contactará un ejecutivo para hacerle saber las recomendaciones necesarias.' | translate}}
      </span>
    </div>
  </div>

</ng-template>

<!-- Amounts Template -->
<ng-template #amountsTemplate>

  <!--Total-->
  <div *ngIf="order?.rate?.offerAmount > 0">
    <div class="my-3 row">
      <div class="col-6 col-md-9 col-lg-9">
        <span>{{ 'SubTotal' | translate }}</span>
      </div>
      <div class="col-6 col-md-3 col-lg-3 d-flex justify-content-end align-items-end">
        <span class="price">{{ order.rate.finalAmount + order?.rate?.offerAmount | currency }} MXN</span>
      </div>
    </div>

    <div class="my-3 row">
      <div class="col-6 col-md-9 col-lg-9">
        <span>{{ 'Ahorro' | translate }}</span>
      </div>
      <div class="col-6 col-md-3 col-lg-3 d-flex justify-content-end align-items-end">
        <span class="price">-{{ order?.rate?.offerAmount | currency }} MXN</span>
      </div>
    </div>
  </div>

  <div class="my-3 row">
    <div class="col-6 col-md-9 col-lg-9">
      <span class="text-uppercase">{{ 'Total con IVA' | translate }}</span>
    </div>
    <div class="col-6 col-md-3 col-lg-3 d-flex justify-content-end align-items-end">
      <span class="price text-green fs-l">{{ order.rate.finalAmount | currency }} MXN</span>
    </div>
  </div>

</ng-template>

<!-- Payment receipt Template-->
<ng-template #paymentReceiptTemplate>
  <div *ngIf="order.paymentInfo" class="border-card p-3 mt-3">
    <span class="my-3 fs-l fw-bold"> {{ 'Información del comprobante' | translate }} </span>

    <div class="pt-3 pb-2">
      <hr class="hr-custom" />
    </div>

    <div *ngIf="isBankDepositMethod" class="row">
      <div class="col-12 col-md-6 my-1">
        <span class="fs-m fw-bold">{{ 'Fecha límite de pago' | translate }}</span>
      </div>
      <div class="col-12 col-md-6 my-1">
        <span class="fs-m">{{ order.paymentInfo.bankDepositPaymentInfo[0].deadLineTime | date: 'dd/MM/yyyy'
          }}</span>
      </div>
    </div>

    <div class="row align-items-center">
      <div class="col-12 col-md-6 my-1">
        <span class="fs-m fw-bold"> {{ 'Forma de pago' | translate }} </span>
      </div>
      <div class="col-12 col-md-6 my-1">
        <span class="fs-m">{{ order.paymentInfo.paymentTypeName | translate }}</span>
      </div>
    </div>

    <ng-container *ngIf="order.paymentInfo && isPaymentEnabled">
      <div class="row mb-0 align-items-center">
        <div class="col-12 col-md-6 my-1">
          <span class="fs-m fw-bold fw-bold">{{ 'Tipo de comprobante' | translate }}</span>
        </div>
        <div class="col-12 col-md-6 my-1">
          <span class="fs-m">{{ order.paymentInfo.invoiceTypeName | translate }}</span>
        </div>

        <div class="col-12 col-md-6 my-1">
          <span class="fs-m fw-bold">{{ 'Datos del comprobante' | translate }}</span>
        </div>
        <div class="col-12 col-md-6 my-1">
          <span class="d-block">{{order.paymentInfo.rfc.billingRfc}}</span>
          <span class="d-block">{{ order.paymentInfo.rfc.tradeName }}</span>
        </div>
      </div>
      <ng-container *ngIf="isBankDepositMethod; then bankDepositTemplate"></ng-container>
    </ng-container>
  </div>
</ng-template>

<!-- Bank deposit template -->
<ng-template #bankDepositTemplate>
  <div *ngFor="let bankInfo of order.paymentInfo.bankDepositPaymentInfo" class="row align-items-center pt-2 pt-md-0">
    <div class="col-12 col-md-6 my-1">
      <span class="fs-m fw-bold"> {{ 'Banco' | translate }}</span>
    </div>
    <div class="col-12 col-md-6 my-1">
      <span class="fs-m"> {{ bankInfo.bank | translate }}</span>
    </div>

    <div class="col-12 col-md-6 my-1">
      <span class="fs-m fw-bold"> {{ 'Convenio' | translate }}</span>
    </div>
    <div class="col-12 col-md-6 pb-2 pb-md-0">
      <span class="fs-m"> {{ bankInfo.covenant | translate }}</span>
    </div>

    <div class="col-12 col-md-6 my-1">
      <span class="fs-m fw-bold"> {{ 'Referencia' | translate }}</span>
    </div>
    <div class="col-12 col-md-6 my-1">
      <span class="fs-m"> {{ bankInfo.reference | translate }}</span>
    </div>
  </div>

  <div class="my-3 mb-0 pb-2">
    <hr class="hr-custom" />
  </div>

  <div class="fw-normal fs-md">
    <span class="d-inline-block mb-4">
      {{'El comprobante de pago estará disponible para consulta en la sección "Pagos y Renovaciones", opción
      "Historial", una vez que la Institución Bancaria de tu preferencia nos haya confirmado el pago realizado.' |
      translate }}
    </span>
    <span class="d-inline-block mb-4">
      {{
      'Para depósitos con cheque, éste debe ser emitido a nombre de "Akky Online Solutions, S.A de C.V."' | translate
      }}
    </span>
  </div>
</ng-template>

<!-- Error template -->
<ng-template #errorTemplate>
  <div class="col-lg-8 col-md-12 col-12 p-3 pt-0 px-sm-0 pb-3 m-0">
    <div class="d-flex flex-row content-hover warning">
      <div role="alert" aria-live="polite" [attr.aria-label]="message" class="message-container  d-flex">
        <span class="flex-shrink-0 i-warn ms-2 mt-3"></span>
        <div class="custom-message-warning">
          {{ order.error.message }}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-dialog [(show)]="showSurveyModal"
            [enableCloseDialogButton]="true"
            [enableConfirmButton]="false"
            [hasCallBack]="false">

  <iframe *ngIf="qualtricsUrl"
          class="survey-iframe"
          [src]="qualtricsUrl"
          frameborder="0">
  </iframe>

</app-dialog>
